import { PureComponent } from 'react'
import Loadable from 'react-loadable'
import PropTypes from 'prop-types'
import { getContext, compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { fetchGifs } from 'shared/redux/fetch-gifs'
import { toggleEditMode, updateEditMode, setBulkEditGifIds } from 'shared/redux/edit-mode'
import { setStoryEditMode } from 'shared/redux/story-edit-mode'
import * as selectors from 'shared/redux/reducers'
import GifMenu from 'shared/components/gif-menu/gif-menu'
import Post from 'shared/components/gif-grid/post'
import mapPosts from 'shared/components/gif-grid/map-posts'
import { Loader } from 'shared/components/preloader-animation'
import { relativeUrl } from 'shared/util/url'
import { mapGroupId, mapGridProps } from './map-grid-props'
import relativeGifUrls from './relative-gif-urls'
import { trackEvent } from '../gif-grid/track-grid-events'
import { gridSpacing } from 'shared/css/grid.css'
import { addLastSearchResponseId } from 'shared/util/get-last-search-id'
import pingbackGridEnhancer from 'shared/pingbacks/pingback-grid-enhancer'
import css from './grid.css'
import isMobile from 'shared/util/is-mobile'
import { trackEvent as trackGifDetailEvent, Actions as GifDetailActions } from '../../util/gif-detail-ga-events'
import { processDefaultGifs, PROCESSOR_MAP } from 'shared/util/gif-process'

import Grid from '@giphy/react-giphy-grid'
const PINGBACK_RESPONSE_IDS = {}

const GifEditPanel = Loadable({
    loader: () => import(/* webpackChunkName: "gifEditPanel" */ 'shared/components/edit-panel/gif-modal'),
    loading: () => null,
})

// const Grid = Loadable({
//     loader: () => import(/* webpackChunkName: "reactGiphyGrid" */ '@giphy/react-giphy-grid'),
//     loading: () => null,
// })

const HulkEditor = Loadable({
    loader: () => import(/* webpackChunkName: "hulkEditor" */ 'shared/components/hulk-editor'),
    loading: () => null,
})

const Storybook = Loadable({
    loader: () => import(/* webpackChunkName: "storybookModal" */ 'shared/components/story/storybook'),
    loading: () => null,
})

const OverlayElement = props => (props.gif.post ? <Post {...props} /> : <GifMenu {...props} />)

const defaultProps = isMobile()
    ? {
          showTags: false,
          showTV: false,
          showOverlay: false,
          columns: 2,
          gutter: 6,
          noEditMode: true,
      }
    : {
          showTags: true,
          showTV: true,
          showOverlay: true,
          columns: 4,
          gutter: parseInt(gridSpacing),
          showHulkEditor: true,
          noEditMode: false,
      }
@mapGroupId()
@connect(
    (state, { groupId, excludeGifIds }) => ({
        autoPlay: selectors.getAutoPlay(state),
        gifs: selectors.getGifs(state, groupId, excludeGifIds),
        editMode: selectors.getEditMode(state),
        searchType: selectors.getSearchType(state),
        searchResponseId: selectors.getResponseId(state),
        isFetching: selectors.getFetching(state, groupId),
        isBulkEditing: selectors.getIsBulkEditMode(state),
        isEditingStory: selectors.getIsStoryEditMode(state),
        user: selectors.getUser(state),
    }),
    { fetchGifs, toggleEditMode, updateEditMode, setBulkEditGifIds, setStoryEditMode },
)
@mapGridProps()
@mapPosts()
@relativeGifUrls()
@pingbackGridEnhancer()
class SearchGrid extends PureComponent {
    static contextTypes = {
        router: PropTypes.object,
    }
    static propTypes = {
        category: PropTypes.string.isRequired,
        // grab all the gifs, no groupId required
        allGifs: PropTypes.bool,
        // we want groupId to be required unless allGifs is specified
        groupId: ({ allGifs, groupId }, propName, componentName) => {
            if (!allGifs && !groupId) {
                return new Error(
                    'groupId prop is required for `' +
                        componentName +
                        '`, or use prop `allGifs=true` to get all the gifs',
                )
            }
        },
        autoPlay: PropTypes.bool,
        gifs: PropTypes.array,
        editMode: PropTypes.object,
        searchResponseId: PropTypes.string,
        isFetching: PropTypes.bool,
        isBulkEditing: PropTypes.bool,
        isEditingStory: PropTypes.bool,
        columns: PropTypes.number,
        gutter: PropTypes.number,
        gridTemplate: PropTypes.string,
        searchType: PropTypes.string,
        showTags: PropTypes.bool,
        showTV: PropTypes.bool,
        showOverlay: PropTypes.bool,
        fetchGifs: PropTypes.func,
        toggleEditMode: PropTypes.func,
        updateEditMode: PropTypes.func,
        user: PropTypes.object,
        setBulkEditGifIds: PropTypes.func,
        noEditMode: PropTypes.bool,
        processor: PropTypes.func,
        onLoadMore: PropTypes.func,
        apiKey: PropTypes.string,
    }
    static defaultProps = {
        ...defaultProps,
        onGifSeen: () => {},
        onGifHover: () => {},
        onGifClick: () => {},
    }
    componentWillMount() {
        this.mapPingbackResponseIds()
    }
    componentDidUpdate(prevProps) {
        if (prevProps.gifs !== this.props.gifs) {
            this.mapPingbackResponseIds()
        }
    }
    mapPingbackResponseIds() {
        const { gifs, searchResponseId } = this.props
        if (searchResponseId) {
            gifs.forEach(({ id }) => (PINGBACK_RESPONSE_IDS[id] = PINGBACK_RESPONSE_IDS[id] || searchResponseId))
            addLastSearchResponseId(searchResponseId)
        }
    }
    trackGA(action, label) {
        const { category } = this.props
        trackEvent({
            category,
            action,
            label,
        })
    }
    onClick(e, gifObject, user) {
        const { id } = gifObject
        const { router } = this.context
        const { category, onGifClick, locationState } = this.props
        if (category === 'related') {
            // any grid on a gif detail is related
            trackGifDetailEvent(GifDetailActions.relatedClick, id)
        } else {
            this.trackGA('GIF Click', id)
        }
        onGifClick(gifObject, user, PINGBACK_RESPONSE_IDS[gifObject.id] || category, category)
        if (!e.metaKey && router) {
            const {
                history: { push },
            } = router
            e.preventDefault()
            push(relativeUrl(e.currentTarget.href), locationState)
        }
    }
    closeEditMode = () => {
        const { toggleEditMode, updateEditMode } = this.props
        toggleEditMode()
        updateEditMode()
    }
    render() {
        const {
            gifs,
            showTags,
            isFetching,
            fetchGifs,
            autoPlay,
            groupId,
            columns,
            category,
            gutter,
            editMode,
            setBulkEditGifIds,
            tvConfig,
            showHulkEditor,
            showOverlay,
            showTV,
            noEditMode,
            onGifSeen,
            onGifHover,
            isOffScreen,
            isBulkEditing,
            isEditingStory,
            user,
            processor = processDefaultGifs,
            pingback_id,
            onLoadMore,
            apiKey,
        } = this.props
        const isEditing = isEditingStory || isBulkEditing
        const isLoggedInStaff = user && user.loggedIn && user.isStaff

        return (
            <div className={isEditing ? css.gridBulk : css.grid} key={groupId}>
                <Grid
                    gifs={gifs}
                    autoPlay={autoPlay}
                    showTags={showTags}
                    columns={columns}
                    gutter={gutter}
                    overlayElement={showOverlay ? <OverlayElement category={category} /> : null}
                    selectionMode={isBulkEditing}
                    onSelectionUpdate={setBulkEditGifIds}
                    tvConfig={showTV ? tvConfig : null}
                    onGifSeen={gifObject =>
                        onGifSeen(gifObject, user, PINGBACK_RESPONSE_IDS[gifObject.id] || category, category)
                    }
                    onGifHover={gifObject =>
                        onGifHover(gifObject, user, PINGBACK_RESPONSE_IDS[gifObject.id] || category, category)
                    }
                    onGifClick={(e, gifObject) =>
                        this.onClick(e, gifObject, user, PINGBACK_RESPONSE_IDS[gifObject.id] || category, category)
                    }
                    onGifRightClick={(e, { id }) => this.trackGA('GIF Right Click', id)}
                    onGifTagClick={(e, tag) => this.trackGA('GIF Tag Click', encodeURI(tag))}
                    onLoadMore={() => {
                        if (!isFetching && !isOffScreen) {
                            onLoadMore
                                ? onLoadMore()
                                : fetchGifs({
                                      groupId,
                                      processor: PROCESSOR_MAP[groupId] || processor,
                                      pingback_id,
                                      apiKey,
                                  })
                        }
                    }}
                />
                <Loader isFetching={isFetching} />
                {isEditingStory && <Storybook isModal />}
                {showHulkEditor && isLoggedInStaff && <HulkEditor />}
                {!noEditMode && editMode && editMode.isEditing && <GifEditPanel onClose={this.closeEditMode} />}
            </div>
        )
    }
}

export default (isMobile() ? compose(withRouter, getContext({ isOffScreen: PropTypes.bool }))(SearchGrid) : SearchGrid)
